import { render, staticRenderFns } from "./ArchivedRestore.vue?vue&type=template&id=6515bcfc&scoped=true&"
import script from "./ArchivedRestore.vue?vue&type=script&lang=js&"
export * from "./ArchivedRestore.vue?vue&type=script&lang=js&"
import style0 from "./ArchivedRestore.vue?vue&type=style&index=0&id=6515bcfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6515bcfc",
  null
  
)

export default component.exports